import { types } from '../types/types'

const initialState = {
    cmpData: [],
}

export const cmpReducer = (state = initialState, action) => {

    switch (action.type) {

        case types.cmpLoaded:
            return {
                cmpData: [...action.payload]
            }

        default:
            return state;
    }
}

export default cmpReducer;